import { render, staticRenderFns } from "./PartCard.vue?vue&type=template&id=17811500&scoped=true&"
import script from "./PartCard.vue?vue&type=script&lang=js&"
export * from "./PartCard.vue?vue&type=script&lang=js&"
import style0 from "./PartCard.vue?vue&type=style&index=0&id=17811500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17811500",
  null
  
)

export default component.exports